// extracted by mini-css-extract-plugin
export default {"nav":"B_Shr9byaH5pUyJdy8Si","top":"I0uAtrC2AYb3nbcdQLKG","content":"QK51UVuSbBxvKDhdsy6P","sticky-separator":"GW6lWA6AgGrNzTuo0L11","footer":"Hi9LYYs6JoMfGt6jE_rD"};